import { SvgIconProps } from '@mui/material';
import { categoryIcons } from '@portals/icons/config/categoryIcons';
import { ComponentType } from 'react';

import { loadIcon } from './loadIcon';

export const loadCategory = (category: string): { Icon: ComponentType<SvgIconProps<'svg'>>; color: string } => {
  const categoryIcon = categoryIcons[category];
  return categoryIcon
    ? { Icon: loadIcon(categoryIcon.icon), color: categoryIcon.color }
    : { Icon: loadIcon(category), color: '#000000' };
};
